(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const categoryButtons = document.querySelectorAll('.faq-category-btn');
    const faqItems = document.querySelectorAll('.faq-item');
    categoryButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selectedCategory = this.getAttribute('data-category');
        categoryButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        faqItems.forEach(item => {
          item.classList.remove('active-category', 'open');
          if (item.getAttribute('data-category') === selectedCategory) {
            item.classList.add('active-category');
          }
        });
      });
    });
    document.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', function() {
        const faqItem = this.closest('.faq-item');
        const isOpen = faqItem.classList.contains('open');
        faqItems.forEach(item => {
          item.classList.remove('open');
          item.querySelector('.faq-toggle-icon').textContent = '+';
        });
        if (!isOpen) {
          faqItem.classList.add('open');
          faqItem.querySelector('.faq-toggle-icon').textContent = '−';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
